import { Alert, Grid } from '@backstage/ui';
import { EntityLayout, EntitySwitch } from '@backstage/plugin-catalog';
import {
  EntityGroupProfileCard,
  EntityMembersListCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';
import { EntityWarningContent } from './common/EntityWarningContent';
import {
  EntityJiraOverviewCard,
  isJiraAvailable,
} from '@roadiehq/backstage-plugin-jira';
import { EntityCodeOwnershipCard } from '@appfolio/backstage-plugin-code-ownership';

export const groupEntity = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid.Root columns="12" gap="4">
        {EntityWarningContent}
        <Grid.Item colSpan={{ initial: '12', md: '6' }}>
          <EntityGroupProfileCard showLinks />
        </Grid.Item>
        <Grid.Item colSpan={{ initial: '12', md: '6' }}>
          <EntityMembersListCard
            showAggregateMembersToggle
            relationAggregation="aggregated"
          />
        </Grid.Item>
        <EntitySwitch>
          <EntitySwitch.Case if={isJiraAvailable}>
            <Grid.Item colSpan={{ initial: '12', md: '6' }}>
              <EntityJiraOverviewCard />
            </Grid.Item>
          </EntitySwitch.Case>
        </EntitySwitch>
      </Grid.Root>
    </EntityLayout.Route>
    <EntityLayout.Route path="/ownership" title="Ownership">
      <Grid.Root columns="12" gap="4">
        <Grid.Item colSpan="12">
          <Alert
            status="info"
            title="Why are there multiple ownership cards?"
            description={
              <>
                <strong>Ownership</strong> links to all the entities that the
                team owns, such as domains, services, libraries, and tools.{' '}
                <strong>Code Ownership</strong> provides links to entities that
                support fine-grained code ownership information.
              </>
            }
          />
        </Grid.Item>
        <Grid.Item colSpan={{ initial: '12', md: '6' }}>
          <EntityOwnershipCard
            entityFilterKind={[
              'API',
              'Component',
              'Domain',
              'Resource',
              'System',
            ]}
            entityLimit={1000}
            relationsType="direct"
          />
        </Grid.Item>
        <Grid.Item colSpan={{ initial: '12', md: '6' }}>
          <EntityCodeOwnershipCard />
        </Grid.Item>
      </Grid.Root>
    </EntityLayout.Route>
  </EntityLayout>
);
